<template>
  <div>
    <v-data-table
      v-model="itemsSelected"
      dense
      :headers="tableHeaders"
      :items="data.items"
      :loading="loading"
      :disabled="loading"
      :search="search"
      class="main-table"
      height="auto"
      :show-select="!hideSelect"
      :items-per-page="itemsPerPage"
      :item-class="rowClass"
      :footer-props="{ 'items-per-page-options': [itemsPerPage] }"
    >
      <template #[`header.data-table-select`]="{ props, on }">
        <div class="d-flex text-center text-jutify-center">
          <v-simple-checkbox
            v-model="selectAll"
            :indeterminate="props.indeterminate"
            v-on="on"
          />
          <div class="text-nowrap">Exportar a Excel</div>
        </div>
      </template>
      <template #[`item.data-table-select`]="{ item, isSelected, select }">
        <v-simple-checkbox
          v-if="isSelectable(item)"
          :value="isSelected"
          @input="select($event)"
        />
      </template>
      <template #top>
        <span class="d-flex align-center pa-2 text-dark font-weight-bold">
          Total del bono {{ total }}
          <v-icon color="success" size="20" class="mx-3"
            >mdi-cash-register</v-icon
          >
          Trimestre: {{ data?.title }}
        </span>
      </template>
      <template #[`item.IMPORTE`]="{ item }">
        <div>{{ formatNumber(item.IMPORTE, '$') }}</div>
      </template>
      <template #[`item.FENTC`]="{ item }">
        <div>
          {{ removeTimeFromDate(item.FENTC) }}
        </div>
      </template>
      <template v-if="!hideTotal" #foot>
        <tfoot>
          <tr class="bg-gray">
            <td colspan="3" class="text-right py-4">
              <b>Notas de crédito aplicadas</b>
            </td>
            <td colspan="2" class="text-left">
              <b> {{ total }}</b>
            </td>
          </tr>
        </tfoot>
      </template>
    </v-data-table>
    <v-sheet color="white" elevation="1" width="40%">
      <v-simple-table dense class="mt-3">
        <template #default>
          <thead>
            <tr>
              <th class="text-left text-dark bg-gray"><b>Bono Ganado</b></th>
              <th class="text-left text-dark">
                <b>{{ formatNumber(data?.cashRegister?.MONTO || 0, '$') }}</b>
              </th>
            </tr>
            <tr>
              <th class="text-left text-dark bg-gray">
                <b>Saldo disponible</b>
              </th>
              <th class="text-left text-dark">
                <b>{{ formatNumber(data?.cashRegister?.DISPO || 0, '$') }}</b>
              </th>
            </tr>
          </thead>
        </template>
      </v-simple-table></v-sheet
    >
  </div>
</template>

<script>
  import numbersFormats from '@/mixins/numbersFormats';
  import dates from '@/mixins/dates.js';
  export default {
    name: 'PopDetailTable',
    mixins: [numbersFormats, dates],
    props: {
      data: {
        type: Object,
        default: () => {},
      },
      headers: {
        type: Array,
        required: true,
      },
      value: {
        type: Array,
        default: () => [],
      },
      search: {
        type: String,
        default: '',
      },
      hideHeaders: {
        type: Array,
        default: () => [],
      },
      itemsPerPage: {
        type: Number,
        default: 5,
      },
      hideSelect: Boolean,
      hideTotal: Boolean,
      loading: Boolean,
    },
    data() {
      return {
        selectAll: false,
      };
    },
    computed: {
      tableHeaders() {
        const hiddenHeadersList = [
          ...(this.hideSelect ? ['data-table-select'] : []),
          ...this.hideHeaders,
        ];

        return this.headers.filter(
          (header) => !hiddenHeadersList.includes(header.value)
        );
      },
      total() {
        if (!this.data.items) return 0;
        return this.formatNumber(
          this.data.items.reduce(
            (sum, item) => sum + Number(item.IMPORTE || 0),
            0
          ),
          '$'
        );
      },
      itemsSelected: {
        set(newValue) {
          const items = newValue.filter((i) => this.isSelectable(i));
          this.$emit('itemSelected', items);
        },
        get() {
          return this.value;
        },
      },
    },
    methods: {
      isSelectable(item) {
        return item.IMPORTE !== '0.00';
      },
      rowClass(item) {
        const customClass = !this.isSelectable(item) ? 'disabled-row' : '';
        return `text-nowrap ${customClass}`;
      },
    },
  };
</script>

<style scoped src="@/assets/css/table.css"></style>
<style scoped>
  .foot-total {
    box-shadow: inset 0px 3px 6px #00000029, 0px 3px 6px #00000029 !important;
    background-color: rgb(242, 242, 242);
  }
  .font-desing {
    font-size: 20px;
    margin-right: 50px;
  }
  ::v-deep .disabled-row td {
    color: #9e9e9e !important;
  }
  ::v-deep .v-data-footer {
    justify-content: flex-end;
  }
</style>
